$(document).ready(function(){
    $('.main-warp-element-slider').slick({
slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        arrows: true,
        dots: false,
        speed: 300,
        centerPadding: '20px',
        infinite: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            centerMode: false,
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  });
$(document).ready(function(){
    $('.cs-gallery-sec').slickLightbox({
        src: 'src',
        itemSelector: '.single-grid-image img',
        background: 'rgba(0, 0, 0, .7)',
        slick: {
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev">Previous</button>',
            nextArrow: '<button type="button" class="slick-next">Next</button>',
        }
    });
});


$(document).ready(function(){
    $('.main-warp-element-quotes-slider').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  });
$(document).ready(function(){
  $('.video-slider').slick({
    slidesToShow: 1,
    arrows: true,
    centerMode: true,
  centerPadding: '160px',
  slidesToShow: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          variableWidth: false
          
        }
      }
    ]
  });
}); 

$(document).ready(function() {
  // Function to handle tab clicks and show respective content
  $('.tablink').click(function() {
    var tabId = $(this).attr('onclick').match(/'(.*?)'/)[1]; // Extract the tab ID
    
    // Hide all tab contents and remove active class from all tabs
    $('.tabcontent').hide();
    $('.tablink').removeClass('active');

    // Show the clicked tab content and add active class to the clicked tab
    $('#' + tabId).show();
    $(this).addClass('active');
    
    // Initialize slider for the clicked tab (assuming slider IDs match tab IDs)
    $('#' + tabId + ' .sliders').slick('setPosition');
  });

  // Show the first tab content by default and add active class to the first tab
  $('#tab1').show();
  $('.tablink[onclick="openTab(\'tab1\')"]').addClass('active');

  // Initialize sliders for each tab
  $('.sliders').each(function() {
    $(this).slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
        infinite: false,
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true
          }
        }
      ]
    });
  });
});

 $(document).ready(function() {
        // Show the first tab by default
        $(".tab-links li:first-child").addClass("active");
        $(".tab-panel:first-child").addClass("active");

        // Tab click event handling
        $(".tab-links a").on("click", function(e) {
            var currentAttrValue = $(this).attr("href");

            // Show/Hide tabs
            $(".tab-panel").removeClass("active");
            $(".tab-links li").removeClass("active");

            $(currentAttrValue).addClass("active");
            $(this).parent().addClass("active");

            e.preventDefault();
        });
    });


// Fade in on scroll (no jQuery)
(() => {
  const selector =
    ".template-index main#MainContent > div.shopify-section, " +
    ".template-index main#MainContent > section.shopify-section.section-blogs";

  let rafId = null;

  function run() {
    rafId = null;

    const pageTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    const pageBottom = pageTop + window.innerHeight;
    const tags = document.querySelectorAll(selector);

    for (const tag of tags) {
      const top = tag.getBoundingClientRect().top + pageTop;

      if (top < pageBottom) tag.classList.add("visible");
      else tag.classList.remove("visible");
    }
  }

  function onScroll() {
    // throttle to animation frame so it’s not doing work 200x/sec
    if (rafId != null) return;
    rafId = requestAnimationFrame(run);
  }

  document.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("load", run);
  run();
})();



// Bug Fix for selection of products that dont exist 04/20/2026, update 05/03/2026 to handle 3 option selectors too: Disable unavailable variant options based on selected combination
(function() {
  function updateVariantOptionAvailability() {
    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return;

    const variants = window.ShopifyAnalytics?.meta?.product?.variants;
    if (!variants || !variants.length) return;

    const selects = variantSelects.querySelectorAll('select');
    if (selects.length < 2) return;

    const parsedVariants = variants.map(v => {
      const parts = v.public_title ? v.public_title.split(' / ').map(p => p.trim()) : [];
      return {
        option1: parts[0] || null,
        option2: parts[1] || null,
        option3: parts[2] || null,
      };
    });

    function filterSelect(selectEl, validValues) {
      selectEl.querySelectorAll('option').forEach(option => {
        const isValid = validValues.includes(option.value);
        option.style.display = isValid ? '' : 'none';
        option.disabled = !isValid;
      });

      if (!validValues.includes(selectEl.value)) {
        selectEl.value = validValues[0];
        selectEl.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function filterOption2() {
      const selected1 = selects[0].value;
      const validOption2 = [...new Set(
        parsedVariants
          .filter(v => v.option1 === selected1)
          .map(v => v.option2)
          .filter(Boolean)
      )];
      filterSelect(selects[1], validOption2);
    }

    function filterOption3() {
      if (selects.length < 3) return;
      const selected1 = selects[0].value;
      const selected2 = selects[1].value;
      const validOption3 = [...new Set(
        parsedVariants
          .filter(v => v.option1 === selected1 && v.option2 === selected2)
          .map(v => v.option3)
          .filter(Boolean)
      )];
      filterSelect(selects[2], validOption3);
    }

    selects[0].addEventListener('change', () => {
      filterOption2();
      filterOption3();
    });

    if (selects.length >= 3) {
      selects[1].addEventListener('change', filterOption3);
    }

    filterOption2();
    filterOption3();
  }

  window.addEventListener('load', updateVariantOptionAvailability);
})();